export default __webpack_public_path__ + "static/media/user_circle.0efa4c48.svg";